import { schema } from 'normalizr';

export const dlosSchema = new schema.Entity(
  'dlos', 
  {},
  { idAttribute: 'guid' }
);